import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Logout } from '../Pages/Logout';


export const ParentAuthGuard = ({ children }) => {
    const { isAuthenticated, user, onLogout } = useContext(AuthContext);
    
    if (new Date(user.validTo) < new Date()) {
        sessionStorage.removeItem('auth');
        onLogout();
        return <Navigate to="/parent-login" replace />
    }

    if (!user.token) {
        return <Navigate to="/parent-login" replace />
    }

    if (!isAuthenticated) {
        return <Navigate to="/parent-login" replace />
    }

    if (user.role === 'Parent') {
        return children ? children : <Outlet />
    }

    return <Navigate to="/" replace />
};